import $ from 'jquery';
import 'slick-carousel';
import Modal from './modal';

class ModalEventsGalley extends Modal {
  constructor() {
    super();
    this.controls = [...this.page.querySelectorAll(`.events .screen-pictures__control`)];
    this.template = this.page.querySelector(`#events-gallery-content`);
    this.screenTitle = this.page.querySelector(`.events .screen__title`);
    this.modalSlides = [];
    this.modalTitles = [];
    this.slider = null;
  }

  init() {
    super.createModal();
    this.createWrap();
    this.bindHandlers();
  }

  toggleModal = (isModalShown) => {
    super._toggleModal(isModalShown);
  };

  createSlider() {
    const container = this.page.querySelector(`#events-slider`);
    const sliderLayout = this.template;

    container.appendChild(sliderLayout.content.cloneNode(true));

    this.slider = this.page.querySelector(`#events-gallery-slides`);
    this.modalSlides = [...this.slider.querySelectorAll(`.modal-events__slide`)];
    this.modalTitles = [...this.page.querySelectorAll(`#events-slider .modal-events__title`)];

    this.initEventsSlider();
  };

  createWrap() {
    super.addLayout(`<div class="modal__slider modal-events" id="events-slider"></div>`);
    this.createSlider();
  }

  initEventsSlider() {
    $(this.slider).slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      useCSS: false,
      fade: true
    });

    let previuosSlide = this.slider.querySelector(`.slick-active .modal-events__slide`).dataset.event;
    let previousTitle =  this.modalTitles.find(title => title.classList.contains(`modal-events__title--visible`));

    $(this.slider).on(`afterChange`, () => {
      const activeSlide = this.slider.querySelector(`.slick-active .modal-events__slide`);
      const activeTitle = this.modalTitles.find(title => title.classList.contains(`modal-events__title--visible`));

      if (previuosSlide !== activeSlide.dataset.event) activeTitle.classList.add(`modal-events__title--hidden`);

      this.toggleModalTitles(activeSlide.dataset.event);

      setTimeout(() => {
        activeTitle.classList.remove(`modal-events__title--hidden`);
      }, 200);

      previuosSlide = activeSlide;
      previousTitle = activeTitle;
    });
  }

  toggleMainTitle(isMainTitleVisible) {
    this.screenTitle.classList.toggle(`screen__title--hidden`, isMainTitleVisible);
  }

  toggleModalTitles(slideId) {
    const activeTitle = this.modalTitles.find(title => title.dataset.event === slideId) || this.modalTitles[0];

    if (!activeTitle) return;

    this.modalTitles.forEach(title => title.classList.remove(`modal-events__title--visible`));

    if (slideId) activeTitle.classList.add(`modal-events__title--visible`);
  }

  onClose = () => {
    this.toggleMainTitle(false);
    this.toggleModalTitles(null);
  };

  bindHandlers() {
    this.controls.forEach((control) => {
      control.addEventListener(`click`, ({target}) => {
        const activeSlide = this.modalSlides.find(slide => slide.dataset.event === target.dataset.id);
        const activeSlideNum = activeSlide && this.modalSlides.indexOf(activeSlide);

        $(this.slider).slick('slickGoTo', activeSlideNum);
        this.toggleMainTitle(true);
        this.toggleModalTitles(target.dataset.id);
        this.toggleModal(true);
      });
    });
  }
}

const modalEventsGallery = new ModalEventsGalley();

export default modalEventsGallery;
